import { MdArrowBackIos } from "react-icons/md";
import styles from "./Assessment.module.css";
import { Link } from "react-router-dom";
import { useState } from "react"; // Import useState hook

export const Assessment = ({ onClose, assessmentId, assessment }) => {
  // State to manage description expansion
  const [showFullDescription, setShowFullDescription] = useState(false);

  const handleBack = () => {
    onClose();
  };

  // Function to truncate description
  const truncateDescription = (text, maxLength) => {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const displayDescription = showFullDescription
    ? assessment.description
    : truncateDescription(assessment.description, 150); // Adjust 150 as needed

  return (
    <div className={styles["assessment-container"]}>
      <div className={styles["assessment-header"]}>
        <div onClick={handleBack} className={styles["assessment-back"]}>
          <MdArrowBackIos
            size={20}
            style={{
              width:"25px",
              height:"25px",
              paddingLeft: "6px"
            }}
          />
        </div>
        <div>
          <h3 className={styles["assessment-title"]}>{assessment.name}</h3>
        </div>
      </div>
      <div className={styles["assessment-info"]}>
        <div className={styles["assessment-card-left"]}>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              width: "90%",
              justifyContent: "center",
              borderRadius: 16,
              overflow: "hidden",
              marginBottom: 10,
            }}
          >
            <img
              src={assessment.imageUrl}
              style={{ width: 424, maxHeight: 290 }}
            />
          </div>
          <p
            className={`${styles.description} ${styles["assessment-description"]}`}
          >
            {displayDescription}
          </p>
          {assessment.description &&
            assessment.description.length > 150 && ( // Only show button if description is longer than truncated length
              <span
                className={styles["show-more-btn"]}
                onClick={() => setShowFullDescription(!showFullDescription)}
              >
                {" "}
                {showFullDescription ? " Show Less" : " Show More"}
              </span>
            )}
          <div className="card-bottom">
            <div className="flex-auto assessment-card-details">
              {assessment.timeDuration} min
            </div>
            <div className="flex-auto  assessment-card-details">
              {assessment.totalQuestions} questions
            </div>
          </div>
        </div>
        <div className={styles["assessment-card-left"]}>
          <p className={styles["subheading"]}>
            What you’ll get from this quiz:
          </p>
          <ul>
            {assessment &&
              assessment.benefits?.map((benefit, key) => (
                <li key={key}>{benefit}</li>
              ))}
          </ul>
          <Link
            to={`/dashboard/assessments/${assessment.urlSlug}`}
            className="assessment-card-btn"
          >
            Let's Begin
          </Link>
        </div>
      </div>
    </div>
  );
};
